import { E_RISK_TYPE, VIEW } from 'interfaces';
import _ from 'lodash';
import {
    IExportChartConfig,
    RISK_CHART_MODES,
} from '../../services/lib/APIServiceInterfaces';
import { globalRiskColor, translateGlobalIndex } from 'utils/renderUtils';

export const getGlobalIndexLabel = (chartConfig: IExportChartConfig) => {
    const globalIndexType = chartConfig.globalIndexTypes[0];
    const globalIndexName = translateGlobalIndex[globalIndexType];
    const globalIndexCountry = chartConfig.macroeconomicsCountry?.[0];
    const globalIndexLabel = globalIndexCountry
        ? `${globalIndexName} (${chartConfig.displayNames.countries[globalIndexCountry].abbreviation})`
        : `${globalIndexName}`;
    return globalIndexLabel;
};

export const getGlobalIndexColor = (chartConfig: IExportChartConfig) => {
    const globalIndexType = chartConfig.globalIndexTypes[0];
    let globalIndexColor;
    if (['real_gdp_growth', 'cpi_inflation'].includes(globalIndexType)) {
        const globalIndexCountry = chartConfig.macroeconomicsCountry?.[0];
        globalIndexColor = chartConfig.colorsStack.countries.find(
            c => c.key === globalIndexCountry
        )?.color;
    } else {
        globalIndexColor = globalRiskColor(globalIndexType);
    }
    return globalIndexColor;
};

export const isContingentMode = (chartConfig: IExportChartConfig) =>
    [
        VIEW.CONTINGENT_GRAPH,
        VIEW.SORT_BY_CONTINGENT_DELTA,
        VIEW.SORT_BY_CONTINGENT_RISK,
    ].includes(chartConfig.viewType);

export const isRiskChart = (riskChartMode: RISK_CHART_MODES) => {
    return [RISK_CHART_MODES.RISK, RISK_CHART_MODES.RISK_AND_PULSE].includes(riskChartMode);
};

export const isPulseChart = (riskChartMode: RISK_CHART_MODES) => {
    return [RISK_CHART_MODES.PULSE, RISK_CHART_MODES.RISK_AND_PULSE].includes(riskChartMode);
};

export const isSingleCountryMode = (chartConfig: IExportChartConfig) =>
    chartConfig.viewType === VIEW.COUNTRY_GRAPH;

export const isSortMode = (chartConfig: IExportChartConfig) =>
    [
        VIEW.SORT_BY_RISK,
        VIEW.SORT_BY_DELTA,
        VIEW.SORT_BY_CONTINGENT_RISK,
        VIEW.SORT_BY_CONTINGENT_DELTA,
    ].includes(chartConfig.viewType);

export const isSingleMode = (chartConfig: IExportChartConfig) => {
    return (
        chartConfig.countries.length === 1 && chartConfig.riskIds.length === 1
    );
};

export const getRiskColor = (
    chartConfig: IExportChartConfig,
    riskId: number
) => {
    if (
        chartConfig.riskType === E_RISK_TYPE.DIMENSIONS ||
        chartConfig.riskType === E_RISK_TYPE.CONTINGENT
    ) {
        return chartConfig.colorsStack.dimensions.find(
            (d: any) => d.key === riskId
        ).color;
    } else {
        return chartConfig.colorsStack.clientFacingIndicators.find(
            (d: any) => d.key === riskId
        ).color;
    }
};